import { gql } from '@apollo/client';
/**
 * Generates (or refreshes) the task list of a deal.
 * @const GenerateTaskListMutation
 * @since 1.0.0
 */
export const GenerateTaskListMutation = gql `
  mutation GenerateTaskListMutation($input: GenerateTaskListInput!) {
    generateTaskList(input: $input) {
      id
    }
  }
`;
